import {isDevXd} from "@Common/ui-components/debug/is-dev";
import {addImageReferenceToProductTags} from "@Common/tools/cc-integration/add-image-reference-to-product-tags";

// loads an image to the image area within the editor - the image path can be a direct HTTP path or a CC reference in
// the format of: user:imagename.ext

export const addImageReferencesToProductTagsFromInitializationData = async (product, userInfo, userDataXd) => {
    if (isDevXd()) console.log("CcEditor.addImageReferencesToProductTagsFromInitializationData", userInfo, userDataXd);

    // check variable values provided for each field on each surface - any that appear as URLs will be checked against
    // user data to find a related asset ID - if exists, then write to product tags
    for (const surfaceName in userInfo?.surfaces) {
        for (const variableName in userInfo.surfaces[surfaceName]) {
            const variableValue = userInfo.surfaces[surfaceName][variableName];
            if (!variableValue.toLowerCase().startsWith("https://")) {
                continue; // skip if not a URL
            }

            for (const {getSources, assetType} of imageSources) {
                const imageSource = getSources(userDataXd).find(el => el.imageUrl === variableValue);
                if (imageSource) {
                    await addImageReferenceToProductTags (product, assetType, imageSource.id, surfaceName, variableName);
                    break;
                }
            }
        }
    }
};

const imageSources = [
    {
        // check for image reference in user headshots
        getSources: (userDataXd) => userDataXd.user.imageGallery?.headshots,
        assetType: "headshot",
    },
    {
        // check for image reference in user logos
        getSources: (userDataXd) => userDataXd.user.imageGallery?.logos,
        assetType: "logo",
    },
    {
        // check for image reference in office logos
        getSources: (userDataXd) => userDataXd.office.imageGallery?.logos,
        assetType: "logo",
    },
    {
        // check for image reference in company logos
        getSources: (userDataXd) => userDataXd.company.imageGallery?.dynamicLogos,
        assetType: "logo",
    },
    {
        // check for image reference in company designations
        getSources: (userDataXd) => userDataXd.company.imageGallery?.designations,
        assetType: "designation",
    },
];
